import { render, staticRenderFns } from "./feriados.vue?vue&type=template&id=2c871771&scoped=true"
import script from "./feriados.vue?vue&type=script&lang=js"
export * from "./feriados.vue?vue&type=script&lang=js"
import style0 from "./feriados.vue?vue&type=style&index=0&id=2c871771&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c871771",
  null
  
)

export default component.exports